import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import { setGlobal } from "reactn";
import styled from "styled-components";

const STORAGE_KEY = "requerimentsModal";
const TTL = 10 * 60 * 1000; // 10 minutos en milisegundos
//TODO: Revisar porque no abre el modal
function getRequerimentsModal() {
	const data = JSON.parse(localStorage.getItem(STORAGE_KEY));
	if (!data) return [];
	const { lines, expires } = data;
	if (Date.now() > expires) {
		localStorage.removeItem(STORAGE_KEY);
		return [];
	}
	return lines || [];
}

function setRequerimentsModal(lines) {
	localStorage.setItem(
		STORAGE_KEY,
		JSON.stringify({
			lines,
			expires: Date.now() + TTL,
		})
	);
}

// Botón dinámico
const ActionButton = styled.button.attrs((props) => ({
	style: { backgroundColor: props.color || "#145AB4" },
}))`
	font-size: 14px;
	font-weight: 500;
	width: 140px;
	height: 40px;
	color: #fff;
	border: none;
	border-radius: 4px;
	margin-left: 16px;
	cursor: pointer;
	transition: box-shadow 0.2s;
	box-shadow: 0 0 0 2px transparent;
	border: 1px solid #d9d9d9;
	&:focus {
		outline: none;
	}
`;

// Contenedor de acciones alineado a la derecha
const ActionsContainer = styled.div`
	display: flex;
	justify-content: flex-end;
	margin-top: 15px;
	width: 100%;
`;

const RequerimentsModal = ({
	line,
	requerimentsPopup,
	trigger = [],
	isHaveTicket = false,
}) => {
	const initialPopupInfo = {
		title: "",
		active: false,
		trigger: [],
		actions: [],
		content: "",
	};

	const [isOpen, setIsOpen] = useState(false);
	const [popupInfo, setPopupInfo] = useState(initialPopupInfo);

	useEffect(() => {
		const lines = getRequerimentsModal();

		if (line && line.slug && lines.includes(line.slug)) {
			setIsOpen(false);
			return;
		}

		const { isHability } = getMetaOptions();

		if (isHability) {
			handleOpen();
		}

		setGlobal({
			habilityTicketAndReservation: {
				ticket: false,
				reservation: false,
			},
		});
	}, [line]);

	const getMetaOptions = () => {
		let isActive = false;
		let isTrigger = false;
		let triggers = [];
		if (
			line &&
			line?.meta &&
			line?.meta.options &&
			line?.meta.options.requerimentsPopups
		) {
			const requerimentsPopups = line.meta.options.requerimentsPopups;
			const optionsLine = Object.keys(requerimentsPopups).map(
				(option) => {
					return {
						key: option,
						value: requerimentsPopups[option],
					};
				}
			);

			const popupInfo = optionsLine.find(
				(option) => option.key === requerimentsPopup
			);

			if (popupInfo) {
				setPopupInfo(popupInfo.value);
				isActive = popupInfo.value.active;
				triggers = popupInfo.value.trigger;

				isTrigger =
					triggers && triggers.length > 0
						? triggers.some((item) => trigger.includes(item))
						: false;
			}
		}

		return {
			isHability: isActive && isTrigger,
			triggers,
		};
	};

	const handleOpen = () => {
		setIsOpen(true);
	};

	const handleAccept = () => {
		setIsOpen(false);

		// Guardar la línea en el localStorage
		if (line && line.slug) {
			const lines = getRequerimentsModal();
			if (!lines.includes(line.slug)) {
				setRequerimentsModal([...lines, line.slug]);
			}
		}

		setGlobal({
			habilityTicketAndReservation: { ticket: false, reservation: false },
		});
	};

	const handleAction = (action) => {
		switch (action) {
			case "accept":
				handleAccept();
				break;
			case "cancel":
				handleClose();
				break;
			default:
				handleClose();
				break;
		}
	};

	const handleClose = () => {
		setIsOpen(false);
		const { triggers } = getMetaOptions();
		const isTicket = triggers.includes("ticket");
		const isReservation = triggers.includes("reservation");

		let ticket = false;
		let reservation = false;

		if (isTicket && isReservation) {
			ticket = isHaveTicket ? false : true;
			reservation = true;
		} else if (isTicket) {
			ticket = isHaveTicket ? false : true;
		} else if (isReservation) {
			reservation = true;
		}

		setGlobal({
			habilityTicketAndReservation: { ticket, reservation },
		});
	};

	if (!isOpen) {
		return null;
	}
	const { content, actions } = popupInfo;

	return (
		<Modal
			// open={isOpen}
			visible={isOpen}
			onCancel={handleClose}
			footer={null}
			centered={true}
			style={{
				height: "auto",
			}}
		>
			<div dangerouslySetInnerHTML={{ __html: content }} />

			<ActionsContainer>
				{[...actions]
					.sort((a, b) => b.order - a.order) // Ordenar de mayor a menor (derecha a izquierda)
					.map((item) => (
						<ActionButton
							key={item.order}
							color={item.color}
							onClick={() => {
								handleAction(item.action);
							}}
						>
							{item.label}
						</ActionButton>
					))}
			</ActionsContainer>
		</Modal>
	);
};

export default RequerimentsModal;
